<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-text overflow-hidden">
					<span><b>角色列表</b></span>
				</div>
				<div class="btnGroups">
					<el-button type="success"
							   size="small"
							   icon="el-icon-check"
							   @click="saveClick('roleMenu')">保存
					</el-button>
				</div>
			</div>
			<div class="w-page-container pdb10">
				<div class="w-table-layout">
					<div class="w-table-content"
						 ref="roleContent"
						 style="overflow-y: auto; border:1px solid #eee">
						<el-tree ref="roleTree"
								 :data="data"
								 :props="defaultProps"
								 :expand-on-click-node="false"
								 :highlight-current="true"
								 default-expand-all
								 show-checkbox
								 node-key="id"
								 :default-checked-keys="treeDefaultCheckedKey"
								 @node-click="nodeClick"
								 @check="treeCheck"></el-tree>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getRoleListById, insertTenantPreinstallRole, getRolesByLimitId } from 'api/system/defaultRole'

export default {
    name: 'defaultRole-tree',
	props: {
		data: {
			type: Array,
			default: () => {
				return []
			}
		},

		value: {
			type: Array,
			default: () => {
				return []
			}
		},

        id: {
            type: String,
            default: ''
        }
	},
	data() {
		return {
			treeDefaultCheckedKey: [],
			dialogObj: {
				title: '',
				visible: false,
				width: '650px',
				mode: 'add'
			},
			defaultProps: {
				children: 'children',
				label: 'role_name'
			},
            checkedKeys: []
		}
	},
	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},
	methods: {
        // 查询已经点击的 -  租户
        getRoleListById(id) {
            getRoleListById({
                id: id
            }).then(res => {
                // console.log(res.data)
                // this.treeDefaultCheckedKey = res.data
                this.$refs.roleTree.setCheckedKeys(res.data)
				this.checkedKeys = res.data
            })
        },

        // 查询已经点击的 -  主体
        getRolesByLimitId(id) {
            getRolesByLimitId({
                id: id
            }).then(res => {
                // console.log(res)
                this.$refs.roleTree.setCheckedKeys(res.data)
            })
        },

		treeCheck(data, node) {
            this.checkedKeys = node.checkedKeys
		},

		saveClick() {
			insertTenantPreinstallRole({
                preinstallId: this.id,
                roles: this.checkedKeys
            }).then(res => {
                // console.log(res)
                this.getRoleListById(this.id)
            })
		},

		nodeClick(obj) {
			this.$emit('row-click', obj.id)
		}
	}
}
</script>

<style lang="less" scoped>
.tree-content {
	overflow-y: auto;
	padding: 5px 0px;
}

.w-table-page {
	padding-bottom: 5px;
}
</style>
